import { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import { FilledInput, Button, FormGroup, FormLabel, FormControl, Box, Grid, Collapse, Divider } from '@material-ui/core';

import AuthContext from '../../context';
import { post } from '../../utils/api-services';
import helpers from '../../utils/helpers';
import themeColors from '../../assets/colors';

const useStyles = makeStyles(() => ({
    buttonContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 5
    },
    storeBtn: {
        width: '100%',
        ...themeColors.blueBtn
    }
}));

const TicketMasterDetailCreateBreakDown = ({ open, onClose, id, permissions, setMaster }) => {

    const classes = useStyles();
    const { showToast, signOut, showLoader } = useContext(AuthContext);
    const [code, setCode] = useState('');

    const validate = () => {
        if (!permissions.update_attr) {
            showToast('You have no permissions for this action', 'error', 6500);
            return false;
        }

        if (!code.trim()) {
            showToast('Code field is required', 'error');
            return false;
        }

        return true;
    }

    const store = async () => {
        const cond = validate();
        if (cond) {
            showLoader(true);
            const response = await post(`/ticketMaster/${id}/storeBreakDown`, { code });
            if (response.status === 200) {
                const { message, data } = response;
                showToast(message);
                setMaster(data);
                onClose();
                clear();
            } else {
                console.log('[TicketMasterDetailCreateBreakDown] store error', response);
                helpers.failRequest(response, showToast, signOut);
            }
            showLoader(false);
        }
    }

    const clear = () => setCode('');

    return (
        <Collapse in={open}>
            <Divider />
            <h3>{'Create new ticket (breakdown)'}</h3>
            <Grid container>
                <Grid item xs={6} md={3}>
                    <FormGroup>
                        <FormLabel>{'Code'}</FormLabel>
                        <FormControl
                            variant='filled'
                            component={Box}
                            width='100%'
                        >
                            <FilledInput
                                type='text'
                                placeholder='Code'
                                value={code}
                                onChange={({ target }) => setCode(target.value)}
                            />
                        </FormControl>
                    </FormGroup>
                </Grid>

                <Grid item xs={6} md={2} xl={1} className={classes.buttonContainer}>
                    <Button
                        variant='contained'
                        color='secondary'
                        style={{ width: '100%' }}
                        onClick={clear}
                    >
                        {'Cancel'}
                    </Button>
                </Grid>
                {
                    (permissions.update_attr) &&
                    <Grid item xs={6} md={2} xl={1} className={classes.buttonContainer}>
                        <Button
                            variant='contained'
                            className={classes.storeBtn}
                            onClick={store}
                        >
                            {'Store'}
                        </Button>
                    </Grid>
                }
            </Grid>
        </Collapse>
    );
}

export default TicketMasterDetailCreateBreakDown;